import { UntypedFormGroup } from '@angular/forms';

export const BirthDateValidator = (formGroup: UntypedFormGroup) => {
	const month = formGroup.controls['birthMonth'].value;
	const day = formGroup.controls['birthDay'].value;
	const year = formGroup.controls['birthYear'].value;

	// Only perform validation if all fields are filled out
	if (month && day && year && year.length === 4) {
		// Create a Date object. Months are 0-based, so subtract 1 from the month.
		const birthDate = new Date(year, month - 1, day);

		// Check if the date is valid (i.e., not a NaN date)
		const validBirthDate =
			birthDate.getFullYear() === parseInt(year, 10) && birthDate.getMonth() === month - 1 && birthDate.getDate() === parseInt(day, 10);

		if (validBirthDate) {
			return null;
		} else {
			return { invalidBirthDate: true };
		}
	}

	// If not all fields are entered, don't validate (no error)
	return null;
};
